import styled from 'styled-components'
import { ProductSearchAutocomplete } from '@/features/shared/components/Autocomplete/ProductSearchAutocomplete'
import { SearchBarWrapper } from '@/features/shared/components/Autocomplete/SearchBarWrapper'
import { useRouteToSearchFromAutocomplete } from '@/features/shared/components/Autocomplete/useRouteToSearchFromAutocomplete'

export const HeaderSearch = () => {
  const onProductSearch = useRouteToSearchFromAutocomplete({
    isMultiStoreSearch: false,
  })
  return (
    <SearchBarWrapper>
      <HeaderSearchAutocomplete
        onProductSearch={onProductSearch}
        showDimEffect
        isMultiStoreSearch={false}
        pinToTop
      />
    </SearchBarWrapper>
  )
}

type PinToTop = { pinToTop: boolean }

const HeaderSearchAutocomplete = styled(ProductSearchAutocomplete)<PinToTop>`
  position: relative;

  & button {
    min-width: ${({ pinToTop }) => (pinToTop ? '2.5rem' : '3.688rem')};
    height: ${({ pinToTop }) => (pinToTop ? '2.5rem' : '3.688rem')};
  }
`
